import React from 'react';
import { Container, Card } from '../design-system';
import { Zap, Shield, Users, Smartphone, Cloud, TrendingUp } from 'lucide-react';

export function Features() {
  const features = [
    {
      icon: Zap,
      title: 'Performance Otimizada',
      description: 'Aplicações rápidas e eficientes que oferecem a melhor experiência aos usuários.'
    },
    {
      icon: Shield,
      title: 'Segurança Avançada',
      description: 'Proteção de dados com as melhores práticas e tecnologias de segurança do mercado.'
    },
    {
      icon: Users,
      title: 'Foco no Usuário',
      description: 'Interfaces intuitivas desenvolvidas pensando na experiência e satisfação do usuário.'
    },
    {
      icon: Smartphone,
      title: 'Design Responsivo',
      description: 'Soluções que funcionam perfeitamente em todos os dispositivos e tamanhos de tela.'
    },
    {
      icon: Cloud,
      title: 'Infraestrutura Cloud',
      description: 'Hospedagem escalável na nuvem para garantir disponibilidade e performance.'
    },
    {
      icon: TrendingUp,
      title: 'Crescimento Escalável',
      description: 'Arquitetura preparada para crescer junto com o seu negócio.'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <Container maxWidth="xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Por que escolher a Gruty?
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Resolvemos problemas reais com soluções digitais, de forma organizada, objetiva e segura.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} hover className="group">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-5 group-hover:bg-indigo-600 transition-colors">
                    <Icon className="w-8 h-8 text-indigo-600 group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600">
                    {feature.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
